import '../main'
import csActionSheet from './src/actionSheet.vue'

csActionSheet.install = function (Vue) {
    Vue.component(csActionSheet.name, csActionSheet)
}

export default csActionSheet


// WEBPACK FOOTER //
// ./src/components/actionSheet/index.js